exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "creditworthiness-mobile-header{display:block;border-bottom:1px solid #dddfe2;padding:0 30px}creditworthiness-mobile-header .title-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}creditworthiness-mobile-header .title-wrapper h1{color:#0072c9;font-family:Stag Sans;font-size:16px;font-weight:400;padding-right:110px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/creditworthiness/creditworthinessMobileHeader/creditworthinessMobileHeader.scss
// module id = 1799
// module chunks = 0